exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".srm-sort-link {\n\tcolor: #449d44;\n\ttext-decoration: none;\n\tfont-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/sala-elenco/sala-elenco.component.css
// module id = 351
// module chunks = 0